<template>
  <div class="flex flex-col space-y-2">
    <lf-h4>
      {{
        $t("DEALS.DEAL_PROGRESS.BUSINESS_TAX_INFO.OTHER_DEDUCTIONS_DETAIL", 2)
      }}
    </lf-h4>
    <div class="flex flex-wrap gap-4">
      <lf-currency
        v-for="deductionDetail in deductionDetails"
        :key="deductionDetail.type"
        class="min-w-50"
        :name="deductionDetail.type"
        :placeholder="deductionDetail.type"
        :model-value="deductionDetail.amount"
      />
      <button
        class="flex w-full items-center justify-center rounded-sm bg-blue-50 p-5 text-xs font-medium text-blue-500 hover:bg-blue-100"
        @click.prevent="addNewDeductionDetail"
      >
        +
        {{
          $t("DEALS.DEAL_PROGRESS.BUSINESS_TAX_INFO.ADD_NEW_DEDUCTION_DETAIL")
        }}
      </button>
      <form
        v-if="showAddDeductionDetail"
        class="flex flex-col space-y-2"
        @submit="submit"
      >
        <div class="flex space-x-2">
          <lf-input
            v-model="newDeductionDetail.type"
            name="type"
            :placeholder="$t('COMMON.TYPE')"
          />
          <lf-currency
            name="amount"
            :placeholder="$t('COMMON.AMOUNT')"
            :model-value="newDeductionDetail.amount"
          />
        </div>
        <div class="flex w-full justify-end">
          <modal-buttons
            class="bg-white !px-0"
            :on-cancel="handleCancel"
            save-is-submit
            no-vertical-padding
          />
        </div>
      </form>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";

import cloneDeep from "lodash/cloneDeep";
import { useForm } from "vee-validate";

import ModalButtons from "@/components/ui/ModalButtons.vue";
import LfCurrency from "@/components/ui/inputs/LfCurrency.vue";
import LfInput from "@/components/ui/inputs/LfInput.vue";

const { value } = defineProps<{ value: { type: string; amount: string }[] }>();
const emit = defineEmits<{
  "deduction-details:updated": [{ type: string; amount: string }[]];
}>();

const deductionDetails = ref(cloneDeep(value));
const newDeductionDetail = ref({ type: "", amount: "" });
const showAddDeductionDetail = ref(false);

const addNewDeductionDetail = () => {
  showAddDeductionDetail.value = true;
};

const handleCancel = () => {
  showAddDeductionDetail.value = false;
};

const { handleSubmit } = useForm({
  initialValues: { ...newDeductionDetail.value },
});

const submit = handleSubmit((values) => {
  deductionDetails.value.push({
    type: values.type,
    amount: values.amount,
  });
  showAddDeductionDetail.value = false;
});

watch(
  deductionDetails,
  () => {
    emit("deduction-details:updated", deductionDetails.value);
  },
  { deep: true }
);
</script>
